import { push } from "connected-react-router";
import authorizeRequest from '../helpers/authorize-request';
import BASE_URL from '../helpers/base-url';
import { get } from 'lodash';

import {
  LOGIN_IS_LOADING,
  LOGIN_OPERATOR_SUCCESS,
  LOGIN_CUSTOMER_SUCCESS,
  LOGIN_FAIL,
  LOGOUT,
  JWT_AUTH_SUCCESS
} from "./types";
import axios from "axios";

export const authUser = token => async (dispatch, getState) => {
  dispatch({
    type: LOGIN_IS_LOADING,
    payload: true
  });

  if (token == null) {
    return dispatch({
      type: LOGIN_IS_LOADING,
      payload: false
    });
  }

  try {
    const response = await axios.get(`${BASE_URL}/api/findUser`, authorizeRequest());

    dispatch({
      type: JWT_AUTH_SUCCESS,
      payload: {
        username: response.data.username,
        isOperator: response.data.isOperator
      }
    });

  } catch (error) {
    console.error(get(error, 'response.data', error));
    dispatch({
      type: LOGOUT,
      payload: false
    });
  }

};

export const loginUser = (username, password, rememberMe) => async dispatch => {
  try {
    const { data: { token } } = await axios.post(`${BASE_URL}/api/login`, { username, password });

    if (token) {
      const responseUser = await axios.get(`${BASE_URL}/api/findUser`, authorizeRequest(token));

      if (responseUser.data.isOperator) {
        dispatch({
          type: LOGIN_OPERATOR_SUCCESS,
          payload: { token, rememberMe }
        });
      } else {
        dispatch({
          type: LOGIN_CUSTOMER_SUCCESS,
          payload: { token, rememberMe }
        });
      }

    } else {
      dispatch({
        type: LOGIN_FAIL
      });
    }
  } catch (err) {
    console.info(err);
    dispatch({
      type: LOGIN_FAIL
    });
  }
};

export const gotoPathOrDashboard = path => dispatch => dispatch(push(path || '/dashboard'));
export const gotoSignIn = path => dispatch => dispatch(push('/sign-in', { from: path }));

export const logout = () => dispatch => {
  dispatch({ type: LOGOUT });
};



// WEBPACK FOOTER //
// ./src/actions/auth_actions.js